"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrazilianSkin = exports.SkinVersions = void 0;
var SkinVersions;
(function (SkinVersions) {
    SkinVersions["Navy"] = "navy";
    SkinVersions["Ollehbet"] = "ollehbet";
    SkinVersions["Betmidas"] = "betmidas";
    SkinVersions["Xrpbet"] = "xrpbet";
    SkinVersions["Oddsgate"] = "oddsgate";
    SkinVersions["Betvivocomz"] = "betvivocomz";
    SkinVersions["Nzgame"] = "nzgame";
    SkinVersions["Lifebetflat"] = "lifebetflat";
    SkinVersions["Betzwin"] = "betzwin";
})(SkinVersions || (exports.SkinVersions = SkinVersions = {}));
const isBrazilianSkin = (skin) => [SkinVersions.Betmidas, SkinVersions.Oddsgate].includes(skin);
exports.isBrazilianSkin = isBrazilianSkin;
//# sourceMappingURL=skin-versions.js.map